
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/schools/[schoolId]",
      function () {
        return require("private-next-pages/schools/[schoolId]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/schools/[schoolId]"])
      });
    }
  